module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABEElEQVQ4T32SaxWBURBFtwQ0QAMNiCACDWigARFoQAIaEEEEGljb+uZbs657nT/3MTNnHmcG/McKeAK3ltugYtgBc2ACXLpzDOh7BbY5piSYAWbddIFmF5J5PwIH4BEkJYGOZ2ABvIrqJDd4mW21FqKCPXDqSCQ0+Ie4RqDjCHAWuQXfwgQ9SgJ7dOKeNRhsFT1JJnBwwgqEGZ2H0BZBnlb49csETtZBBbxbyRBYF7sgscPsCXyoQGTXZv/qrxruQ+7du//nqMBy7T02zuxmjiAreSf9TaZt1yLQqJMDExLHIkWLJm0SZKcYaFblp4LIGFo3VOy/VcUZHEsV7ml5WiRKOC1VCGfVyFLWSJQ79oMPNjU+ER/Y/aMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Assets_.png
// module id = wGqf
// module chunks = 1